<app-navbar [isDarkNavbar]="true"></app-navbar>
<div class="questionnaire-container">
  <div class="router-container">
    <router-outlet></router-outlet>
  </div>
</div>
